"use client";

import { createSystem, defaultConfig } from "@chakra-ui/react";
import { SYSTEM_COMMON } from "./common";

export const SYSTEM_ACOUNT_GDF = createSystem(defaultConfig, SYSTEM_COMMON, {
  theme: {
    tokens: {
      colors: {
        primary: {
          50: { value: "#CBE7D8" },
          100: { value: "#A8D7BE" },
          200: { value: "#63B689" },
          300: { value: "#63B689" },
          400: { value: "#49A573" },
          500: { value: "#3D8B61" },
          600: { value: "#337552" },
          700: { value: "#295E42" },
          800: { value: "#235038" },
          900: { value: "#193A28" },
        },
        secondary: {
          50: { value: "#FEF5F5" },
          100: { value: "#FCD8D7" },
          200: { value: "#FAB4B3" },
          300: { value: "#F78484" },
          400: { value: "#F56564" },
          500: { value: "#D45150" },
          600: { value: "#B34444" },
          700: { value: "#903736" },
          800: { value: "#7A2F2E" },
          900: { value: "#592221" },
        },
      },
    },
  },
});
